export type ClockLocationLike = {
  label?: string | null;
  lat?: number | null;
  lng?: number | null;
};

/** Display clock punch location as a place or area name — never raw coordinates. */
export function formatClockLocationLabel(
  loc?: ClockLocationLike | null,
  fallback = 'Area unknown'
): string {
  if (!loc) return fallback;
  const label = loc.label?.trim();
  if (label) return label;
  return fallback;
}
